module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickaway),
      expression: "onClickaway"
    }],
    staticClass: "color-input"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_picker),
      expression: "show_picker"
    }],
    staticClass: "color-picker"
  }, _vm._l((_vm.colors), function(color) {
    return _c('div', {
      staticClass: "color-box",
      style: ({
        "background": "#" + color
      }),
      on: {
        "click": function($event) {
          return _vm.setColor(color)
        }
      }
    })
  }), 0), _c('div', {
    staticClass: "color-box",
    style: ({
      "background": "#" + _vm.value
    }),
    on: {
      "click": function($event) {
        _vm.show_picker = !_vm.show_picker
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff5902f8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tags/color_input.vue
// module id = 1241
// module chunks = 1